import React, { useState } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { Formik, Field } from "formik";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
  FieldInputDollar,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  ssnMasking,
  clearFieldValues,
} from "../../../utils";
import {
  getPlanSummaryReportInfo,
  getDownloadPlanSummaryReport,
  getCompaniesDropDown,
  getPlansDropDown,
  getSponsorOrganizationList,
  getMasterPlanList,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import "react-input-range/lib/css/index.css";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ColumnMenu } from "../402ContributionLimit/columnMenu";
import { Tooltip } from "@progress/kendo-react-tooltip";
import data from "../../Mapper/MapAndTransform/sampleData";
import { GridInnerFilters } from "../../../components/GridInnerFilters/GridInnerFilters";

class KendoGridDecimalCell extends React.Component {
  render() {
    const value = this.props.dataItem[this.props.field];
    if (value != null) return <td>$ {value.toFixed(2)}</td>;
    else return <td> </td>;
  }
}

class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}
const today = new Date();
const initialValues = {
  //companyName: "Select One",
  companyId: null,
  payDateTo: new Date(today.setDate(today.getDate())),
  payDateFrom: new Date(today.setDate(today.getDate() - 30)),
};

//const selectOne = { label: "Select One", value: null };
const allOption = { label: "All", value: null };

const emptycol = [
  {
    value: 0,
    label: "",
    className: "",
    columnName: "",
    field: "",
    width: 0,
    dataType: "",
    field1: "",
  },
];
const columns = [
  {
    value: 1,
    label: "Company Name",
    className: "column-companyName",
    columnName: "companyName",
    field: "companyName",
    width: 173,
    dataType: "alphaNumeric",
    field1: "companyName",
  },
  {
    value: 2,
    label: "Plan ID",
    className: "column-rkPlanNumber",
    columnName: "rkPlanNumber",
    field: "rkPlanNumber",
    width: 173,
    dataType: "alphaNumeric",
    field1: "rkPlanNumber",
  },
  {
    value: 3,
    label: "Plan Name",
    className: "column-planName",
    columnName: "planName",
    field: "planName",
    width: 173,
    dataType: "alphaNumeric",
    field1: "planName",
  },
  {
    value: 4,
    label: "Plan Group Names",
    className: "column-planGroupNames",
    columnName: "planGroupNames",
    field: "planGroupNames",
    width: 173,
    dataType: "alphaNumeric",
    field1: "planGroupNames",
  },
  {
    value: 5,
    label: "Pay Date",
    className: "column-payDate",
    columnName: "payDate",
    field: "payDate",
    width: 173,
    dataType: "date",
    field1: "payDateFrom",
    field2: "payDateTo",
  },
  {
    value: 6,
    label: "File Name",
    className: "column-fileName",
    columnName: "fileName",
    field: "fileName",
    width: 180,
    dataType: "alphaNumeric",
    field1: "fileName",
  },
  {
    value: 7,
    label: "No. of Participants",
    className: "column-noOfParticipants",
    columnName: "noOfParticipants",
    field: "noOfParticipants",
    width: 180,
    dataType: "alphaNumeric",
    field1: "noOfParticipants",
  },
  {
    value: 8,
    label: "Total Pre-Tax",
    className: "column-totalPreTax",
    columnName: "totalPreTax",
    field: "totalPreTax",
    width: 133,
    dataType: "amount",
    field1: "totalPreTaxFrom",
    field2: "totalPreTaxTo",
  },
  {
    value: 9,
    label: "Total Roth",
    className: "column-totalRoth",
    columnName: "totalRoth",
    field: "totalRoth",
    width: 133,
    dataType: "amount",
    field1: "totalRothFrom",
    field2: "totalRothTo",
  },
  {
    value: 10,
    label: "Total Match",
    className: "column-totalMatch",
    dataType: "amount",
    columnName: "totalMatch",
    field: "totalMatch",
    width: 133,
    field1: "totalMatchFrom",
    field2: "totalMatchTo",
  },
  {
    value: 11,
    label: "Total Profit Sharing",
    className: "column-totalProfitSharing",
    columnName: "totalProfitSharing",
    dataType: "amount",
    field: "totalProfitSharing",
    width: 233,
    field1: "totalProfitSharingFrom",
    field2: "totalProfitSharingTo",
  },
  {
    value: 12,
    label: "Total Safe Harbor",
    className: "column-totalSafeHarbor",
    columnName: "totalSafeHarbor",
    field: "totalSafeHarbor",
    dataType: "amount",
    width: 233,
    field1: "totalSafeHarborFrom",
    field2: "totalSafeHarborTo",
  },
  {
    value: 13,
    label: "Total QMAC",
    className: "column-totalQMAC",
    columnName: "totalQMAC",
    field: "totalQMAC",
    width: 233,
    dataType: "amount",
    field1: "totalQMACFrom",
    field2: "totalQMACTo",
  },
  {
    value: 14,
    label: "Total QNEC",
    className: "column-totalQNEC",
    columnName: "totalQNEC",
    field: "totalQNEC",
    width: 233,
    dataType: "amount",
    field1: "totalQNECFrom",
    field2: "totalQNECTo",
  },
  {
    value: 15,
    label: "Total ER Safe Harbor Nonmatch (Non-Elective)",
    className: "column-totalERSafeHarborNonmatchNonElective",
    columnName: "totalERSafeHarborNonmatchNonElective",
    field: "totalERSafeHarborNonmatchNonElective",
    width: 370,
    dataType: "amount",
    field1: "totalERSafeHarborNonmatchNonElectiveFrom",
    field2: "totalERSafeHarborNonmatchNonElectiveTo",
  },
  {
    value: 16,
    label: "Total Loan Repayments",
    className: "column-totalLoanRepayments",
    columnName: "totalLoanRepaymentAmount",
    field: "totalLoanRepaymentAmount",
    width: 233,
    dataType: "amount",
    field1: "totalLoanRepaymentAmountFrom",
    field2: "totalLoanRepaymentAmountTo",
  },
  {
    value: 17,
    label: "File Total",
    className: "column-fileTotal",
    columnName: "fileTotal",
    field: "fileTotal",
    width: 233,
    dataType: "amount",
    field1: "fileTotalFrom",
    field2: "fileTotalTo",
  },
  {
    value: 18,
    label: "Total Compensation",
    className: "column-totalCompensation",
    columnName: "totalCompensation",
    field: "totalCompensation",
    width: 233,
    dataType: "amount",
    field1: "totalCompensationFrom",
    field2: "totalCompensationTo",
  },
];

const PlanSummary = (props) => {
  const [final, setFinal] = useState(columns);
  const [gridFilters, setGridFilters] = useState();
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [pageCount, setPageCount] = useState(1);

  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
  ]);
  const [totalRecord, setTotalRecord] = useState(0);
  const formName = manageReportsFormNames.PLAN_SUMMARY;
  const fields = formFields[formName];
  const [companyList, setCompanyList] = useState("");
  const [sponsorList, setSponsorList] = useState("");
  const [planList, setPlanList] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [filteredValues, setFilteredValues] = useState({
    from: 1,
    count: 20,
  });
  const [trigger, setTrigger] = useState(true);

  const [isScroll, setIsScroll] = useState(false);
  const [sorting, setSorting] = useState();
  const [tableContent, setTableContent] = useState([]);

  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });
  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });

  const apiCall = (data) => {
    setDataLoading(true);
    getPlanSummaryReportInfo(data)
      .then((response) => {
        setDataLoading(false);
        setTableContent(response.planSummaryReport);
        setTotalRecord(response.count);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
        //handle error
      });

    //setToggle(!toggle);
  };
  //   const setHardErrorAsZero = (props) => {
  //     const { dataItem } = props;
  //     if (dataItem.numberOfHardErrors != 0) return dataItem.numberOfHardErrors;
  //     else return 0;
  //   };
  //   const setSoftErrorAsZero = (props) => {
  //     const { dataItem } = props;
  //     if (dataItem.numberOfSoftErrors != 0) return dataItem.numberOfSoftErrors;
  //     else return 0;
  //   };

  useDeepEffect(() => {
    if (!isEmpty(companyList) || !isEmpty(sponsorList)) {
      setFilteredValues({
        ...filteredValues,
        innerFilters: gridFilters,
      });
      apiCall({ ...filteredValues, innerFilters: gridFilters });
    }
  }, [gridFilters]);
  const onSubmit = (values) => {
    setGridFilters(null);
    if (values.companyId !== null || values.sponsorOrganizationId !== null) {
      setCompanyList(values.companyName);
      setSponsorList(values.sponsorOrganizationName);
      setPageCount(1);
      setIsScroll(true);
      //setTableContent([]);
      var filters = {
        companyId: values.companyId ? values.companyId : 0,
        sponsorOrganizationId: values.sponsorOrganizationId
          ? values.sponsorOrganizationId
          : 0,
        planId: values.companyId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        masterPlanId: values.sponsorOrganizationId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        payDateFrom: usDateFormat(values.payDateFrom),
        payDateTo: usDateFormat(values.payDateTo),
        from: 1,
        count: 20,
        innerFilters: null,
        selectedColumns: selectedColumns,
      };
      setFilteredValues(filters);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setTableContent([]);
      setCompanyList("");
      setSponsorList("");
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId,
          planId: filteredValues.planId,
          masterPlanId: filteredValues.masterPlanId,
          payDateFrom: usDateFormat(filteredValues.payDateFrom),
          payDateTo: usDateFormat(filteredValues.payDateTo),
          from: fromCount,
          count: 20,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        getPlanSummaryReportInfo(filters)
          .then((response) => {
            setDataLoading(false);
            if (response.planSummaryReport.length === 0) {
              setIsScroll(false);
            } else {
              setTableContent([...tableContent, ...response.planSummaryReport]);
            }
          })
          .catch((error) => {
            setDataLoading(false);
          });
      }
    }
  };

  const showManageColumns = () => {
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };
  const hideColumns = () => {
    setSelectedColumns([final.map((item) => item.value)]);

    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "block") {
      x[0].style.display = "none";
    } else {
      x[0].style.display = "block";
    }
  };

  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  const applyColumns = () => {
    if (selectedColumns.length >= 1) {
      setFinal(
        columns.filter((column) =>
          selectedColumns.map((x) => x).includes(column.value)
        )
      );
      setIsScroll(true);
    } else {
      setFinal(emptycol);
      setIsScroll(false);
    }
    hideColumns();
  };

  const exportReportFile = () => {
    var column = columns.filter(
      (column) => !final.map((item) => item.value).includes(column.value)
    );
    var data = column.map((item) => item.value);
    getDownloadPlanSummaryReport({ ...filteredValues, selectedColumns: data })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `PlanSummaryReport_ ${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return (
      <td>
        {value ? (
          <div>{value}</div>
        ) : value == 0 ? (
          <div> 0</div>
        ) : (
          <div> -</div>
        )}
      </td>
    );
  };
  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };
  const ssnGridCell = (props) => {
    var value = ssnMasking(props.dataItem.ssn);
    return renderValue(value);
  };

  return (
    <ManageReportLayout rptName="Plan Summary">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];
              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToExculde: [fields.payDateFrom, fields.payDateTo],
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,
                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                });

                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(sponsors[value].id) : null,
                  [fields.sponsorOrganizationName]:
                    value || value === 0 ? sponsors[value].name : "Select One",
                });

                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex ">
                    <div className="d-flex mr-2">
                      <Field
                        size="sm"
                        isRequired
                        label={`Sponsoring organization ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.sponsorOrganizationName}
                        value={values[fields.sponsorOrganizationName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.companyName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.companyName]) ? (
                            <div style={{ width: "130px" }}>
                              {" "}
                              Select a sponsoring organization or company{" "}
                            </div>
                          ) : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Sponsor Organization"
                            // options={sponsoringOrganisationList}
                            options={
                              sponsors && [
                                //selectOne,
                                ...sponsors.map((sponsor, index) => ({
                                  label: sponsor.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => OnSponsorChange(value)}
                            selectedValue={
                              values[fields.sponsorOrganizationName]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="sm"
                        isRequired
                        label={`Company Name ${
                          !values[fields.sponsorOrganizationName] ? "*" : ""
                        }`}
                        name={fields.companyName}
                        value={values[fields.companyName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.sponsorOrganizationName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.sponsorOrganizationName])
                            ? " "
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                ...companies.map((company, index) => ({
                                  label: company.companyName,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div className="d-flex ml-3">
                        <Field
                          size="sm"
                          isRequired
                          label={`plan Id ${
                            !values[fields.companyName] ? "*" : ""
                          }`}
                          name={fields.planName}
                          value={
                            values[fields.planName]
                              ? values[fields.planName]
                              : values[fields.companyName] && "All"
                          }
                          placeholder="Select"
                          direction="bottom"
                          validate={(value) =>
                            values[fields.sponsorOrganizationName] &&
                            ["", undefined, null, "Select One"].includes(value)
                              ? "Select a plan"
                              : null
                          }
                          popupContent={
                            <SearchableList
                              options={selectPlanOptions}
                              onSelect={(value) => onPlanChange(value)}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Pay date from "
                          isRequired
                          name={fields.payDateFrom}
                          value={usDateFormat(values[fields.payDateFrom])}
                          direction="bottom"
                          isDatePicker
                          onClear={() =>
                            setFieldValue(fields.payDateFrom, null)
                          }
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.payDateFrom, value)
                              }
                              value={usDateFormat(values[fields.payDateFrom])}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Pay date to"
                          isRequired
                          name={fields.payDateTo}
                          value={usDateFormat(values[fields.payDateTo])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.payDateTo, null)}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.payDateTo, value)
                              }
                              value={usDateFormat(values[fields.payDateTo])}
                            />
                          }
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              ""
                            ) : value < values[fields.payDateFrom] ? (
                              <div style={{ width: "150px" }}>
                                {" "}
                                Should be ahead of "Pay date from"
                              </div>
                            ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                            undefined;
                          }}
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    <Button
                      className=" mt-12 sort-button mr-3"
                      variant="secondary"
                      style={{ marginTop: "30px" }}
                      onClick={(e) => {
                        setValues({
                          ...clearFieldValues({
                            values,
                            fieldsToClear: [
                              fields.planId,
                              fields.planName,
                              fields.companyId,
                              fields.companyName,
                              fields.sponsorOrganizationName,
                              fields.sponsorOrganizationId,
                              fields.payDateFrom,
                              fields.payDateTo,
                            ],
                          }),
                        });
                        setFieldValue(
                          fields.payDateFrom,
                          initialValues.payDateFrom
                        );
                        setFieldValue(
                          fields.payDateTo,
                          initialValues.payDateTo
                        );
                        setFieldValue(fields.planName, null);
                        setFieldValue(fields.planId, null);
                        setPlanList([]);
                        setErrors({});
                        setTotalRecord(0);
                        setTableContent([]);
                        setCompanyList("");
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      className="mt-12 sort-button"
                      style={{
                        lineHeight: "19px",
                        marginLeft: "8px",
                        marginTop: "30px",
                      }}
                      variant="secondary"
                      type="submit"
                    >
                      Search
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div className="d-flex justify-content-between align-center divSpace header-button min-width-200">
          <div className="d-flex flex-col">
            <div
              style={{ fontSize: "14px", color: "#828282", paddingTop: "6px" }}
            >
              {companyList ? `Showing result for ${companyList} company` : null}
            </div>
            <div className="ft-12 grey-text font-weight-500">
              {totalRecord} Records found
            </div>
          </div>
          <div className="d-flex pad-top-10">
            <div style={{ diplay: "flex", flexDirection: "column" }}>
              <div>
                <Button
                  variant="secondary"
                  className="column-header"
                  onClick={showManageColumns}
                >
                  <span className="marg-right-6">
                    <i class="fal fa-columns"></i>
                  </span>
                  Column
                </Button>
              </div>
              <div
                className="manage-column-dropdown"
                style={{ display: "none" }}
              >
                <div className="manage-columns ">
                  <p className="manage-columns-button"> Manage columns</p>
                  <p
                    className="apply-button"
                    onClick={() => {
                      hideColumns();
                      setTrigger(!trigger);
                    }}
                  >
                    Close
                  </p>
                </div>
                <div>
                  <MultiSelectDropdown
                    hideSelectedOptions="FALSE"
                    width="269px"
                    height="200px"
                    maxHeight="300px"
                    position="absolute"
                    background="white"
                    zIndex="2"
                    options={columns}
                    onSelect={(value) => {
                      setSelectedColumns(value);
                    }}
                    name={"Columns"}
                    value={selectedColumns}
                    trigger={trigger}
                    // disabled={}
                    // isTypeAhead={isEdit}
                  />
                </div>
                <div style={{ marginTop: "220px", paddingLeft: "100px" }}>
                  <Button onClick={applyColumns}>Apply</Button>
                </div>
              </div>
            </div>
            <div className="ft-12 grey-text font-weight-500 marg-right-5">
              <Button
                className="export-button"
                title="Export Excel"
                variant="secondary"
                style={{ border: "none" }}
                // onClick={<ExcelExport />}
                onClick={() => !isEmpty(tableContent) && exportReportFile()}
              >
                <Image src={ExcelImage} width="20px" />
                Export
              </Button>
            </div>
          </div>
        </div>
        <div className="table-width grid-overflow" style={{ minWidth: "0px" }}>
          <ExcelExport data={tableContent}>
            <LoaderWrapper isLoading={dataLoading}>
              <Tooltip
                openDelay={100}
                position="bottom"
                anchorElement="element"
              >
                <Grid
                  data={tableContent}
                  total={tableContent.length}
                  resizable={true}
                  onScroll={scrollHandler}
                  style={{ height: "400px" }}
                  fixedScroll
                >
                  {final.map((column, idx) => (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={column.label}
                      filter={column.dataType}
                      cell={
                        (column.dataType === "amount" &&
                          KendoGridDecimalCell) ||
                        (column.dataType === "date" && dateForm) ||
                        renderValue
                      }
                      headerCell={ProductNameHeader}
                      columnMenu={(props) =>
                        !isEmpty(tableContent) ||
                        (gridFilters &&
                          (gridFilters[column.field1] ||
                            (column.field2 && gridFilters[column.field2]))) ? (
                          <GridInnerFilters
                            {...props}
                            fields={fields}
                            sorting={sorting}
                            setSorting={setSorting}
                            gridFilters={gridFilters}
                            setGridFilters={setGridFilters}
                            field1={column.field1}
                            field2={column.field2 ? column.field2 : null}
                            columns={selectedColumns}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Grid>
              </Tooltip>
            </LoaderWrapper>
          </ExcelExport>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default PlanSummary;
